import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary">
                    <h2>متاسفانه خطایی رخ داده است</h2>
                    <button onClick={() => window.location.reload()}>تلاش مجدد</button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary; 